export default __webpack_public_path__ + "static/media/hero-bg.97893289.jpg";